import type { ApiClient } from '../api/client';

export const TERMINAL_FILE_UPLOAD_MAX_BYTES = 25 * 1024 * 1024;

export type TerminalFileUploadResult = {
  path: string;
  filename: string;
  byte_size: number;
  sha256: string;
  used_fallback: boolean;
};

export function shellQuoteTerminalPath(path: string): string {
  return `'${path.replace(/'/g, `'"'"'`)}'`;
}

export async function uploadTerminalFile(
  apiClient: ApiClient,
  executorId: string,
  sessionId: string,
  file: File
): Promise<TerminalFileUploadResult> {
  if (file.size > TERMINAL_FILE_UPLOAD_MAX_BYTES) {
    throw new Error(
      `File is too large (maximum ${TERMINAL_FILE_UPLOAD_MAX_BYTES / 1024 / 1024}MB)`
    );
  }
  const path =
    `/api/executors/nodes/${encodeURIComponent(executorId)}` +
    `/terminal/sessions/${encodeURIComponent(sessionId)}/files` +
    `?filename=${encodeURIComponent(file.name)}`;
  return apiClient.upload<TerminalFileUploadResult>(path, file);
}
